export default "__VITE_ASSET__B0bme1jR__"